import React from "react";
import { ExtendedNodeData, RCCGrid, RCCIcon, RCCIIconTypes } from "react-common-components";
import AppIcons from "src/components/AppIcons";
import LovPermissionsMenu from "src/components/Lov/PermissionsMenu";
import { useAuth } from "src/context/Auth/context";
import { IPermissions } from "src/context/Auth/interface";
import { useTranslation } from "src/context/Translations/context";
import StyledSpan from "./styles";

const HierarchyNode: React.FC<ExtendedNodeData> = ({
	node,
	register,
	control,
	parentNode,
	permissionsData,
	changeChildrensSelect
}) => {
	const {checkIfHasContractPermission, superUser, businessGroup} = useAuth();
	const {translate} = useTranslation();
	const dontHaveContractPermission = parentNode != null ? !checkIfHasContractPermission(node.efb001Codigo) : node.children.find((x: any) => checkIfHasContractPermission(x.efb001Codigo)) === undefined;
	const defaultValuePermission = parentNode != null ? permissionsData.find((x: IPermissions) => x.path === node.efb001Codigo) : undefined;
	const defaultValueLovPermission = node.permissionDefaultValue ?? defaultValuePermission?.permission.toString();
	return(
		<RCCGrid container item alignItems="center" justifyContent="space-between">
			<span title={node.name} style={{ display: "flex", alignItems: "center", flex: 1, height: "100%"}}>
				{dontHaveContractPermission ? (
					<RCCIcon name="diamond" size={24} color="var(--grey-soft)"/>
				): (
					<>
						{node.icon && (
							<RCCIcon name={node.icon ? node.icon as RCCIIconTypes : "chart"} size={24} color="var(--grey-soft)"/>
						)}
						{node.img && (
							<AppIcons name={node.img} />
						)}
					</>
				)}
            &nbsp;
				<StyledSpan>
					{translate(node.efb005Descricao)}
				</StyledSpan>
			</span>
			{parentNode != null && ((superUser && businessGroup.efa001Id === 1) || !dontHaveContractPermission) && (
				<RCCGrid container item xs={4} sm={3} md={2} style={{ minWidth: "52px" }}>
					<input type="hidden" {...register(`${node.efb001Codigo}.id`)} name={`${node.efb001Codigo}.id`} value={defaultValuePermission ? defaultValuePermission.id.toString() : undefined} />
					<input type="hidden" {...register(`${node.efb001Codigo}.path`)} name={`${node.efb001Codigo}.path`} value={node.efb001Codigo} />
					<LovPermissionsMenu 
						name={`${node.efb001Codigo}.permission`}
						control={control}
						label=""
						defaultValue={defaultValueLovPermission !== "-1" ? defaultValueLovPermission : undefined}
						styleInline="height: 32px; min-height: 32px; min-width: 57px;"	
						isClearable
					/>
				</RCCGrid>
			)}
			{parentNode == null && ((superUser && businessGroup.efa001Id === 1) || !dontHaveContractPermission) && (
				<RCCGrid container item xs={4} sm={3} md={2} style={{ minWidth: "52px" }}>
					<LovPermissionsMenu 
						name={`remove_${node.efb001Codigo}`}
						control={control}
						label=""
						defaultValue={node.permissionDefaultValue ?? node.permission}
						styleInline="height: 32px; min-height: 32px; min-width: 57px;"	
						onChangeCapture={(e: any) => changeChildrensSelect(node.efb001Codigo, e.value)}
					/>
				</RCCGrid>
			)}
		</RCCGrid>
	);};

export default HierarchyNode;
